export default "__VITE_ASSET__JODT5Kwm__"